import React, { useState } from "react";

const faqs = [
  {
    question: "How do I reset my password?",
    answer: "Go to the login screen, click 'Forgot Password,' and follow the instructions.",
  },
  {
    question: "How do I report a bug?",
    answer: "Email us with details about the issue at support@realsync.app.",
  },
];

const SupportPage = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="min-h-screen bg-gray-100 text-gray-900">
      {/* Header */}
      <header className="bg-blue-600 text-white py-4 shadow-md">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="text-3xl font-bold">Support - RealSync</h1>
          <p className="text-sm mt-1">Need help? Find answers below or contact us.</p>
        </div>
      </header>

      {/* Content Section */}
      <div className="max-w-3xl mx-auto mt-10 p-6 bg-white shadow-lg rounded-lg">
        {/* Contact Section */}
        <section className="mb-6 text-center">
          <h2 className="text-xl font-semibold">Contact Us</h2>
          <p className="mt-2 text-gray-700">
            Email:{" "}
            <a
              href="mailto:support@realsync.app"
              className="text-blue-600 hover:underline font-medium"
            >
              support@realsync.app
            </a>
          </p>
        </section>

        {/* FAQ Section */}
        <section>
          <h2 className="text-xl font-semibold mb-4 text-center">FAQs</h2>
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div key={index} className="border border-gray-300 rounded-lg">
                <button
                  className="w-full text-left px-4 py-3 flex justify-between items-center bg-gray-200 hover:bg-gray-300 rounded-t-lg"
                  onClick={() => toggleFAQ(index)}
                >
                  <span className="font-medium">{faq.question}</span>
                  <span className="text-xl">{openIndex === index ? "−" : "+"}</span>
                </button>
                {openIndex === index && (
                  <div className="p-4 bg-white text-gray-700">{faq.answer}</div>
                )}
              </div>
            ))}
          </div>
        </section>

        {/* Additional Resources */}
        <section className="mt-6 text-center">
          <h2 className="text-xl font-semibold">Additional Resources</h2>
          <div className="mt-2">
            <a
              href="/privacy-policy"
              className="text-blue-600 hover:underline font-medium block"
            >
              Privacy Policy
            </a>
            <a
              href="/terms-of-service"
              className="text-blue-600 hover:underline font-medium block mt-1"
            >
              Terms of Service
            </a>
          </div>
        </section>
      </div>
    </div>
  );
};

export default SupportPage;
